import { CampaignDataProps } from '@/types/campaignProps'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface CampaignsStateProps {
  campaigns: CampaignDataProps[]
  hasLoaded: boolean
}

const initialState: CampaignsStateProps = {
  campaigns: [],
  hasLoaded: false,
}

const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    handleSetCampaigns(
      state,
      action: PayloadAction<{ campaigns: CampaignDataProps[] }>,
    ) {
      state.campaigns = action.payload.campaigns
      state.hasLoaded = true
    },
    handleResetCampaigns(state) {
      state.campaigns = []
      state.hasLoaded = false
    },
  },
})

export const { handleSetCampaigns, handleResetCampaigns } =
  campaignsSlice.actions

export default campaignsSlice.reducer
